if (!customElements.get('gg29-sticky-buy')) {
  customElements.define(
    'gg29-sticky-buy',
    class Gg29StickyBuy extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!this.mainButton) return;

        this.button = this.querySelector('[data-gg29-sticky-button]');
        this.priceEl = this.querySelector('[data-gg29-sticky-price]');
        this.variantEl = this.querySelector('[data-gg29-sticky-variant]');

        this.button.addEventListener('click', () => this.mainButton.click());

        // Show only once the real button has scrolled above the screen. Checked on every scroll (not an
        // IntersectionObserver) so jumps past the button, like a reload halfway down, still show the bar.
        this.hidden = false;
        this.onScroll = () => {
          this.classList.toggle('is-visible', this.mainButton.getBoundingClientRect().bottom < 0);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onScroll();

        // Mirror the real button's sold-out / disabled state and label.
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
        this.syncButton();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            this.syncVariant(event.data.variant);
          });
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.buttonObserver?.disconnect();
        this.unsubscribe?.();
      }

      syncButton() {
        const disabled = this.mainButton.hasAttribute('disabled');
        this.button.disabled = disabled;
        const label = this.mainButton.querySelector('span')?.textContent.trim();
        if (label) this.button.textContent = label;
      }

      syncVariant(variant) {
        // The real price block already has the right format and currency, so copy it.
        const root = document.getElementById(`price-${this.sectionId}`);
        const mainPrice = root?.querySelector('.price--on-sale')
          ? root.querySelector('.price__sale .price-item--last')
          : root?.querySelector('.price__regular .price-item--regular');
        if (mainPrice) this.priceEl.textContent = mainPrice.textContent.trim();
        if (this.variantEl && variant && variant.title !== 'Default Title') this.variantEl.textContent = variant.title;
      }
    }
  );
}
